import React from "react";
import {
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";

import "./style.css";

const FormDropdown = ({
  id,
  name,
  label = "",
  placeholder = "-- Select an option -- ",
  required,
  options = [],
  value,
  errorText,
  onChangeValue = () => {},
  valueExtractor = "value",
  labelExtractor = "label",
}) => {
  return (
    <Grid container direction="column" className="form-dropdown gap-y-8">
      {label && (
        <Typography variant="body2" className="form-label">
          {label}
          {required && <span> *</span>}
        </Typography>
      )}
      <FormControl>
        <Select
          id={id}
          name={name}
          variant="outlined"
          value={value || ""}
          onChange={onChangeValue}
          displayEmpty
          renderValue={(selected) => {
            if (!selected) {
              return <span className="placeholder-text">{placeholder}</span>;
            }
            const selectedOption = options.find(
              (opt) => opt.value === selected,
            );
            return selectedOption ? selectedOption.label : selected;
          }}
        >
          {options.map((element) => (
            <MenuItem key={element?.value} value={element[valueExtractor]}>
              {element[labelExtractor]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {errorText && (
        <Typography variant="caption" className="error-text">
          {errorText}
        </Typography>
      )}
    </Grid>
  );
};

export default FormDropdown;
